export { ClassRoster } from './widgets/class-roster';
export { Instructor } from './widgets/instructor';
export { Member } from './widgets/member';
export { svc as rostersvc, RosterMember } from './support/svc';
